import type React from 'react';
import { DisclosureButton, DisclosurePanel } from '@headlessui/react';
import Link from 'next/link';
import appUtils from '../../../../../utils/appUtils';
import { localeArray as locales } from '../../../../../constants/LocaleConstants';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { getClassNameForMobile } from '../../nav-helpr';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@lb-service/ui';
import { useCookies } from 'react-cookie';

interface Props {
  currentLocale: string;
}

const GuestHeaderMobile: React.FC<Props> = ({ currentLocale }) => {
  const { t, i18n } = useTranslation('common');
  const language = i18n.language;
  const router = useRouter();
  const [_cookies, setCookie] = useCookies(['NEXT_LOCALE']);
  const { pathname: currentPath } = useRouter();
  const baseUrl = appUtils.getSiteUrl(language);
  const langOptions = locales.map((loc) => {
    const key = `locale-${loc.language}`;
    return (
      <SelectItem key={key} value={loc.value}>
        {loc.language}
      </SelectItem>
    );
  });

  const handleSelectLang = (value: string) => {
    if (value !== currentLocale) {
      i18n.changeLanguage(value);
      setCookie('NEXT_LOCALE', value, {
        path: '/',
        domain:
          process.env.NEXT_PUBLIC_NODE_ENV === 'dev'
            ? 'lingualbox.loc'
            : 'lingualbox.com',
      });
      router.replace(router.pathname, router.asPath, { locale: value });
    }
  };

  return (
    <DisclosurePanel className="md:hidden">
      {({ close }) => (
        <div className="pt-2 pb-3 space-y-1">
          {/* Current: "bg-indigo-50 border-indigo-500 text-indigo-700", Default: "border-transparent text-default hover:bg-gray-50 hover:border hover:text-gray-700" */}
          <DisclosureButton
            as={Link}
            href={`${baseUrl}/school/learn-spoken-english`}
          >
            <a
              className="border-transparent text-default px-1 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
              onClick={() => close()}
            >
              {t('service.header.school')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href="/tutors">
            <a
              className={getClassNameForMobile('/tutors', currentPath)}
              onClick={() => close()}
            >
              {t('service.header.tutors')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href={`${baseUrl}/courses`}>
            <a
              className="border-transparent text-default px-1 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
              onClick={() => close()}
            >
              {t('service.header.courses')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href={`${baseUrl}/pricing`}>
            <a
              className="border-transparent text-default px-1 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
              onClick={() => close()}
            >
              {t('service.header.pricing')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href={`/login`}>
            <a
              className="border-transparent text-default px-1 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
              onClick={() => close()}
            >
              {t('service.header.login')}
            </a>
          </DisclosureButton>
          <DisclosureButton as={Link} href={`/signup`}>
            <a
              className="border-transparent text-default px-1 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
              onClick={() => close()}
            >
              <button
                type="button"
                className="relative inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary shadow-sm hover:bg-primary-active focus:outline-none focus:ring-2"
              >
                <span>{t('service.header.signup')}</span>
              </button>
            </a>
          </DisclosureButton>
          <div className="border-transparent text-default px-1 block pl-3 pr-4 py-2 border-l-4 text-base font-medium">
            <Select value={currentLocale} onValueChange={handleSelectLang}>
              <SelectTrigger className="w-[120px]">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>{langOptions}</SelectContent>
            </Select>
          </div>
        </div>
      )}
    </DisclosurePanel>
  );
};

export default GuestHeaderMobile;
